import { sortCallback } from '@anecdotes/utils';
import { ChangeDetectionStrategy, Component, HostBinding, Input, OnInit } from '@angular/core';
import { Observable, map } from 'rxjs';
import { OptionStateWithCount } from '../../models';
import { DataFilterManagerService } from '../../services';

@Component({
  selector: 'app-filter-tabs',
  templateUrl: './filter-tabs.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FilterTabsComponent implements OnInit {
  @HostBinding('class')
  private readonly classes = 'flex gap-3 border-bottom border-navy-50';

  /** Filter instance id to link this dropdown to */
  @Input()
  filterInstanceId: string;

  /** Filter field id to link this dropdown to in the given filter instance */
  @Input()
  filterFieldId: string;

  options$: Observable<OptionStateWithCount[]>;

  constructor(private dataFilterManagerService: DataFilterManagerService) {}

  ngOnInit(): void {
    this.options$ = this.dataFilterManagerService
      .getOptionsWithCountForFieldSelector(this.filterInstanceId, this.filterFieldId)
      .pipe(
        map((options) => {
          return options.filter((opt) => opt.count || opt.showOnZeroCount);
        }),
        map((options) => {
          return [...options].sort((fst, scd) => sortCallback(fst, scd, (option) => (option.isFixed ? 0 : 1)));
        }),
      );
  }

  selectOption(optionState: OptionStateWithCount): void {
    this.dataFilterManagerService.selectOptions(this.filterInstanceId, { [this.filterFieldId]: [optionState.id] });
  }

  protected selectDispayValue(optionState: OptionStateWithCount): string {
    let displayValue = optionState.value;

    if (optionState.translationKey) {
      displayValue = optionState.translationKey;
    }

    return displayValue;
  }
}
